document.addEventListener('DOMContentLoaded', () => {

	const bootcampHero = document.querySelector('.pageBootcamp__hero');
	if (bootcampHero != undefined || bootcampHero != null) {

		// Collapsible home
		var accItem = document.getElementsByClassName('pageBootcamp__program__accordion__item');
		var accHD = document.getElementsByClassName('pageBootcamp__program__accordion__item__head');
		for (i = 0; i < accHD.length; i++) {
			accHD[i].addEventListener('click', toggleItem, false);
		}
		function toggleItem() {
			var itemClass = this.parentNode.className;
			for (i = 0; i < accItem.length; i++) {
				accItem[i].className = 'pageBootcamp__program__accordion__item pageBootcamp__program__accordion__item--closed';
			}
			if (itemClass == 'pageBootcamp__program__accordion__item pageBootcamp__program__accordion__item--closed') {
				this.parentNode.className = 'pageBootcamp__program__accordion__item pageBootcamp__program__accordion__item--opened';
			}
		}

		// Flickity Carousel


		var elem = document.querySelector('.main-carousel');
		var flkty = new Flickity(elem, {
			// options
			cellAlign: 'left',
			contain: true,
			prevNextButtons: false,
			fade: true,
			wrapAround: true
		});

		var elem2 = document.querySelector('.main-carousel2');
		var flkty = new Flickity(elem2, {
			// options
			cellAlign: 'left',
			contain: true,
			prevNextButtons: false,
			fade: true,
			wrapAround: true,
			autoPlay: true,
		});

	}


	// Collapsible modules
	var module = document.getElementsByClassName('pageBootcampModules__sidebar__module');
	var moduleHead = document.getElementsByClassName('pageBootcampModules__sidebar__module__head');
	for (i = 0; i < moduleHead.length; i++) {
		moduleHead[i].addEventListener('click', toggleModule, false);
	}
	function toggleModule() {
		var moduleClass = this.parentNode.className;
		for (i = 0; i < module.length; i++) {
			module[i].className = 'pageBootcampModules__sidebar__module pageBootcampModules__sidebar__module--closed';
		}
		if (moduleClass == 'pageBootcampModules__sidebar__module pageBootcampModules__sidebar__module--closed') {
			this.parentNode.className = 'pageBootcampModules__sidebar__module pageBootcampModules__sidebar__module--opened';
		}
	}

	// Mobile Tab

	var tabBootcamp = document.getElementById('tabBootcamp')
	var tabProgressBootcamp = document.getElementById('tabProgressBootcamp')
	var content = document.getElementsByClassName('pageBootcampModules__content')[0];
	var sidebar = document.getElementsByClassName('pageBootcampModules__sidebar')[0];

	function tabBootcampClick() {
		content.style.display = "block";
		sidebar.style.display = "none";
		tabBootcamp.classList.add('pageBootcampModules__mobiletab__link--active');
		tabProgressBootcamp.classList.remove('pageBootcampModules__mobiletab__link--active');
	}

	function tabProgressBootcampClick() {
		content.style.display = "none";
		sidebar.style.display = "block";
		tabBootcamp.classList.remove('pageBootcampModules__mobiletab__link--active');
		tabProgressBootcamp.classList.add('pageBootcampModules__mobiletab__link--active');
	}

	if (tabBootcamp != null) {
		tabBootcamp.onclick = tabBootcampClick;
		tabProgressBootcamp.onclick = tabProgressBootcampClick;
	}


	// Close modal certificate

	var btncloseModalCertificate = document.getElementsByClassName('pageBootcampModules__modal__close')[0];
	var modalCertificate = document.getElementsByClassName('pageBootcampModules__modal')[0];

	function closeModalCertificate() {
		modalCertificate.classList.add('ac-none');
	}

	if (btncloseModalCertificate != null) {
		btncloseModalCertificate.onclick = closeModalCertificate;
	}

});


